// Configuration interface
export interface AppConfig {
  apiUrl: string;
  enableAuthentication: boolean;
  authClientId?: string;
  authTenantId?: string;
  authAuthority?: string;
  authApiScope?: string;
  environment: string;
}

// Load configuration - CRA's webpack will replace process.env.REACT_APP_* at build time
// Simple direct approach - no runtime override logic needed for production

let apiUrl = process.env.REACT_APP_API_URL || '';

// If API URL is not set or looks like a placeholder, try to infer it
if (!apiUrl || apiUrl.startsWith('${')) {
  // Attempt inference #1: If running on the web container FQDN, swap '-web' with '-api'
  const host = (typeof window !== 'undefined' && window.location) ? window.location.origin : '';
  if (host && /-web[.-]/i.test(host)) {
    apiUrl = host.replace('-web', '-api');
  } else if (host) {
    // Attempt inference #2: Use same origin (assuming a reverse proxy path /api)
    apiUrl = host;
  } else {
    // Fallback to localhost dev default
    apiUrl = 'https://localhost:7032';
  }
}

export const appConfig: AppConfig = {
  apiUrl: apiUrl,
  enableAuthentication: process.env.REACT_APP_ENABLE_AUTH === 'true',
  authClientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  authTenantId: process.env.REACT_APP_AUTH_TENANT_ID,
  authAuthority: process.env.REACT_APP_AUTH_AUTHORITY,
  authApiScope: process.env.REACT_APP_AUTH_API_SCOPE,
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development'
};

// Ensure apiUrl ends with /api (no trailing slash duplication)
if (!/\/api\/?$/i.test(appConfig.apiUrl)) {
  appConfig.apiUrl = appConfig.apiUrl.replace(/\/$/, '') + '/api';
}